  <div class="swiper">
    <div class="swiper-wrapper" id="swippy">
    </div>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
  